module.exports = __webpack_public_path__ + "static/media/belasting-5.86dec0be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/belasting-5.svg
// module id = 83
// module chunks = 0